// -*- Mode: rjsx -*-
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';

import { FHMaterialStyles } from "../../../ui/fh-material-styles.js";

import { Claim } from '../../claim';
import { Notification } from '../../notifications';
import { Details as ClientDetails } from '../../client';

import Details from './Details.jsx';

import { CARD_TITLE_PROPS } from '..';

function SideNotification(props) {
    return (
        <Card>
          <CardHeader title="Notifications" titleTypographyProps={CARD_TITLE_PROPS} />
          <CardContent>
            <Notification request={props.request} />
          </CardContent>
        </Card>
    );
}




function Sidebar(props) {
    const [value, setValue] = useState(0);
    const dispatch = useDispatch();
    const classes = FHMaterialStyles();
    
    return(
        <Grid spacing={1} container direction="column">

          <Grid item >
            <Claim request={props.request} />
          </Grid>
          
          {/* <Grid item  style={{ width: "100%" }}> */}
          {/*   <SideNotification request={props.request} />           */}
          {/* </Grid> */}

          <Grid item >
            <Details request={props.request} />
          </Grid>

          <Grid item >
            <ClientDetails user={props.request.user} titleProps={CARD_TITLE_PROPS} />
          </Grid>          

          
		  {/* <h1>Side</h1> */}
          {/* <span>{value}</span> */}
          {/* <button onClick={() => dispatch({ type: 'increment-counter' })}> */}
          {/*       Increment counter */}
          {/* </button> */}
          
        </Grid>
    );
}

export default Sidebar;
